import uploadscontactUspagebannerbgimagecontactUsBannerJpg from "$lib/data/generated/uploads/contact us/PageBanner/bgImage/Contact Us Banner.jpg";

export const uploads = {
  "uploads/contact us/PageBanner/bgImage/Contact Us Banner.jpg": uploadscontactUspagebannerbgimagecontactUsBannerJpg
};